module.exports = __webpack_public_path__ + "static/media/wmsui32_1000.5991d67d.ico";